import React from "react";
import { Menu, Empty, Badge, Button, Icon } from "antd";
import PropTypes from "prop-types";
import { countryFlags, countryNames, productConfig } from "./utils/constants";
import { formatCredit, CreditSymbol } from "./utils/formatters";

/**
 * WalletSidebar - Navigation menu for wallet types and countries
 */
const WalletSidebar = ({
  groupedData,
  selectedType,
  selectedCountry,
  memberBalance,
  onMenuSelect,
  onAddClick,
  getTotalCredits,
  getCountryCredits,
}) => {
  const renderMenu = () => {
    if (Object.keys(groupedData).length === 0) {
      return (
        <div className="wallet-sidebar-empty">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No wallets"
          />
        </div>
      );
    }

    return (
      <Menu
        mode="inline"
        selectedKeys={[`${selectedType}-${selectedCountry}`]}
        defaultOpenKeys={Object.keys(groupedData)}
        className="wallet-sidebar-menu"
      >
        {Object.entries(groupedData).map(([type, countries]) => {
          const config = productConfig[type] || productConfig.sms;
          const totals = getTotalCredits(type);

          return (
            <Menu.SubMenu
              key={type}
              title={
                <span className="wallet-menu-title">
                  <span
                    className="wallet-menu-icon"
                    style={{ color: config.color }}
                  >
                    <Icon type={config.icon} />
                  </span>
                  <span className="wallet-type-name">{type.toUpperCase()}</span>
                  <Badge
                    count={totals.count}
                    style={{ backgroundColor: config.color, marginLeft: 8 }}
                  />
                </span>
              }
            >
              {Object.entries(countries).map(([country]) => {
                const countryTotals = getCountryCredits(type, country);
                const isSelected =
                  selectedType === type && selectedCountry === country;

                return (
                  <Menu.Item
                    key={`${type}-${country}`}
                    onClick={() => onMenuSelect(type, country)}
                    className={isSelected ? "wallet-menu-item-selected" : ""}
                  >
                    <div className="wallet-country-item">
                      <span className="wallet-country-flag">
                        {countryFlags[country] || "🌍"}
                      </span>
                      <span className="wallet-country-name">
                        {countryNames[country] || country}
                      </span>
                      <span className="wallet-country-credit">
                        {type === "sms" ? (
                          <span>
                            <CreditSymbol />
                            {formatCredit(countryTotals.available)}
                          </span>
                        ) : (
                          <span>${formatCredit(countryTotals.available)}</span>
                        )}
                      </span>
                    </div>
                  </Menu.Item>
                );
              })}
            </Menu.SubMenu>
          );
        })}
      </Menu>
    );
  };

  return (
    <div className="wallet-sidebar-wrapper">
      {/* Balance Header */}
      <div className="wallet-sidebar-balance">
        <div className="wallet-balance-label">ACCOUNT BALANCE</div>
        <div className="wallet-balance-value">
          $
          {(memberBalance || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </div>
      </div>

      {/* Menu Content */}
      <div className="wallet-sidebar-content">{renderMenu()}</div>

      {/* Add Credit Button */}
      <div className="wallet-sidebar-footer">
        <Button
          type="primary"
          block
          className="wallet-add-btn"
          onClick={onAddClick}
        >
          <Icon type="plus" /> Add Credit
        </Button>
      </div>
    </div>
  );
};

WalletSidebar.propTypes = {
  groupedData: PropTypes.object.isRequired,
  selectedType: PropTypes.string,
  selectedCountry: PropTypes.string,
  memberBalance: PropTypes.number,
  onMenuSelect: PropTypes.func.isRequired,
  onAddClick: PropTypes.func.isRequired,
  getTotalCredits: PropTypes.func.isRequired,
  getCountryCredits: PropTypes.func.isRequired,
};

WalletSidebar.defaultProps = {
  selectedType: null,
  selectedCountry: null,
  memberBalance: 0,
};

export default WalletSidebar;



// WEBPACK FOOTER //
// ./src/containers/User/UserManagement/components/MemberCreditWallet/WalletSidebar.js